import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import './empty-message.scss';

applyTranslations(require('./empty-message.i18n.json'));

type Props = {
  message?: string | null,
  wrapperClass?: string
};

const EmptyMessage = ({ message, wrapperClass }: Props): JSX.Element => {
  const emptyMessageClasses = classnames('empty-message', {
    [wrapperClass || '']: wrapperClass
  });

  return (
    <div className={emptyMessageClasses}>
      <span>
        {message || __t('empty_message.no_data_label')}
      </span>
    </div>
  );
};

export default EmptyMessage;
